<app-sales-credit-number [creditNumber]="data().number"  [data]="data()"  *ngIf="categoryCode !== 'kredicash' "></app-sales-credit-number>

<div class="container section__creditResume h-full">
  <div class="wrapper">
    <div class="sectionContainer fadeinright animation-duration-200">
      <article class="pb-40">
        <app-sales-breadcrumbs [routes]="routesBreadcrumb"></app-sales-breadcrumbs>

        <div class="mainInfo mb-30">
          <h1>{{ 'Resumen del crédito' | termReplace }}</h1>
        </div>

        <div class="clientBox pb-25">
          <div class="icon">
            <app-client-icon></app-client-icon>
          </div>
          <div class="info">
            <p><strong>Cliente:</strong> {{ data().person?.first_name.toLowerCase() }} {{ data().person?.last_name.toLowerCase() }}</p>
            <p><strong>Documento:</strong> {{ data().person?.document_id_number }}</p>
          </div>
        </div>

        <div class="resumeBox">
          <div class="product mb-20">
            <div class="subtitle mb-10">
              <h2>Te llevarás:</h2>
            </div>

            <div class="product__item">
              <div class="productListItem__cont">
                <div class="img">
                  <img src="assets/images/icon-telefono.svg" [alt]="data().product?.name">
                </div>
                <div class="info">
                  <div class="title">
                    <h3>

                      {{data().product?.name}}
                    </h3>
                  </div>
                  <div class="main-price">
                    <p>{{ getMainProductAmount() | currency}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="additionalProductSummary mb-15" *ngIf="hasAdditionalProduct()">
            <div class="separator">
              <i>
                <app-circle-full-plus-icon></app-circle-full-plus-icon>
              </i>
            </div>

            <div class="subtitle mb-10">
              <h2>Producto adicional</h2>
            </div>

            <div class="additionalProductSummary__item mb-15">
              <div class="additionalProductSummary__itemCont">
                <div class="category">
                  <span>{{ getAdditionalProduct()?.category }}</span>
                </div>

                <div class="info">
                  <h3>{{ getAdditionalProduct()?.name }}</h3>
                  <span>{{ getAdditionalProductNetAmount() | currency}}</span>
                </div>

                <div class="details">
                  <p><span>Monto: <strong>{{ getAdditionalProduct()?.amount | currency}}</strong></span> <span class="circle"></span> <span>Descuento: <strong>{{ getAdditionalProduct()?.discount_pct }}%</strong></span></p>
                </div>
              </div>
            </div>

            <div class="additionalProductSummary__breakdown">
              <div class="title">
                <i>
                  <app-money-white-icon></app-money-white-icon>
                </i>
                <h3>Detalle del crédito</h3>
              </div>

              <div class="summary">
                <ul>
                  <li>
                    <span class="text">Subtotal productos</span>
                    <span class="value">{{ getProductsSubtotal() | currency}}</span>
                  </li>
                  <li>
                    <span class="text">Abono</span>
                    <span class="value">- {{ getInstallmentAmount() | currency}}</span>
                  </li>
                  <li class="highlight">
                    <span class="text">Monto financiado total</span>
                    <span class="value">{{ getFinancedTotalAmount() | currency}}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="credit mb-20">
            <p *ngIf=!macroFlowService.isExperanzaFlow(this.flowCode)>Abono de <strong>{{ data().quotes?.installment.selected | currency}}</strong> y pago de <strong>{{ data().quotes?.quota.selected |  currency }} {{frequencyText()}}</strong> durante <strong>{{ data().quotes?.quota.quantity }} cuotas</strong>.</p>

            <p *ngIf=macroFlowService.isExperanzaFlow(this.flowCode)>Pagarás <strong>{{ data().quotes?.quota.selected | currency}}</strong> mensuales durante <strong>{{ data().quotes?.quota.quantity }} cuotas</strong> descontado de tu boleta de pago de la ONP.</p>
          </div>
        </div>

        <div class="backInnerButton" *ngIf="getCanCancelRequest()">
          <app-sales-cancel-request></app-sales-cancel-request>
        </div>
      </article>

      <footer>
        <div class="footer__content " >
          <button *ngIf="!hideChangeProductButton" pButton pRipple label="Cambiar producto" class="p-button-secondary p-button-raised p-button-rounded n-background" (click)="onNextStep()"></button>

          <button *ngIf="!macroFlowService.isExperanzaFlow(flowCode)" pButton pRipple label="Continuar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onGotoStep(SalesWorkflowSteps['update-client-information'])"></button>

          <button *ngIf="macroFlowService.isExperanzaFlow(flowCode)" pButton pRipple label="Continuar" icon="pi pi-angle-right" iconPos="right" class="p-button-primary p-button-raised p-button-rounded w-full" (click)="onNextStep()"></button>
        </div>
      </footer>
    </div>
  </div>
</div>
